/** @format */

import { createAction, props } from '@ngrx/store';

import { CompareProductDetails } from '@compare/data-access';
import { CompareBarProduct, ProductAvailabilityCollection } from '@shared/data-access/interfaces';

export const setCompareBarProducts = createAction(
	'[Compare] Set the compare products',
	props<{ compareBarProducts: CompareBarProduct[] }>()
);

export const addCompareProduct = createAction(
	'[Product List] add a product to be compared',
	props<{ compareBarProduct: CompareBarProduct }>()
);

export const removeCompareProduct = createAction(
	'[Product List] remove a product from the compare list',
	props<{ ecode: string }>()
);

export const setCompareProductDetails = createAction(
	'[Compare/API] Set Product Details',
	props<{ productDetails: CompareProductDetails }>()
);

export const setCompareSkeletonLoader = createAction(
	'[Compare] Set the compare skeleton loader',
	props<{ isCompareSkeletonLoaderVisible: boolean }>()
);

export const setCompareProductDetailsCallFailed = createAction(
	'[Compare] Set the compare product details call failed',
	props<{ hasProductDetailsCallFailed: boolean }>()
);

export const setIsCompareGridOpen = createAction(
	'[Product List] set the compare grid open status',
	props<{ isCompareGridOpen: boolean }>()
);

export const setCompareProductsAvailability = createAction(
	'[Compare/API] Set Compare Products Availability',
	props<{ compareProductsAvailability: ProductAvailabilityCollection }>()
);
